import DxDataGrid from 'devextreme/ui/data_grid';

export const sortingMethod = (gridInstance: DxDataGrid<any, any>, value1: any, value2: any) => {
  const isSelectedOne = gridInstance?.isRowSelected(value1);
  const isSelectedSecond = gridInstance?.isRowSelected(value2);

  if (isSelectedOne && !isSelectedSecond) {
    return -1;
  }

  if (!isSelectedOne && isSelectedSecond) {
    return 1;
  }

  return 0;
};

export const showPager = (gridInstance: DxDataGrid<any, any>): boolean => gridInstance?.pageCount() > 1;

export const hasLookupValue = (value: unknown): boolean => value !== null && value !== undefined && value !== '';

export const getNullSafeLookupItems = <T extends Record<string, any>>(
  items: T[] | null | undefined,
  valueExpr: keyof T | string,
): T[] => {
  if (!Array.isArray(items)) {
    return [];
  }

  return items.filter(item => hasLookupValue(item?.[valueExpr]));
};
